// extracted by mini-css-extract-plugin
export default {"home":"Home_home__VceHV","main":"Home_main__19nnz"};